import request from '@/lib/api'

const _BASE = "/api";
const BASE_FREE = "/free";

export function getLoginUrl(params) {
  return request({
    url: `${BASE_FREE}/tPmcAuth/getLoginUrl`,
    method: 'get',
    params
  })
}
export function exitFreeLogin(params) {
  return request({
    url: `${BASE_FREE}/public/pmc_exit`,
    method: 'get',
    params
  })
}
export function existLogin(params) {
  return request({
    url: `${_BASE}/public/pmc_exit`,
    method: 'get',
    params
  })
}
//获取用户中心基本信息跳转地址11
export function getUcInfo() {
  return request({
    url: `${_BASE}/public/ucInfo`,
    method: 'get',
  })
}